import { useNavigate } from 'react-router-dom';

import { appManagerActions } from '../../store/appManager/actions';
import './styles/ErrorPiecework.scss';

import { useAppDispatch } from '../../App/redux/store';
import { modalsActions } from '../../features/modals/modalsSlice';
import Button from '../Assets/Button';

function ErrorPiecework() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleClick = () => {
    dispatch(modalsActions.errorPiecework(false));
    dispatch(appManagerActions.selectedAccountTab.set(2));
    navigate(`/mon-compte`);
  };

  return (
    <div className="error-piecework-overlay">
      <div className="error-piecework">
        <h3 className="error-piecework-title">Pige classique</h3>
        <p>
          {`Votre pige n'est pas paramétrée, vous pouvez le faire dans "Mon compte", onglet "Paramètres Pige", ou en cliquant sur le bouton`}
        </p>

        <div className="error-piecework-btns">
          <Button
            btnType="button"
            btnContent="PARAMETRER"
            handleClick={handleClick}
            primary
          />
        </div>
      </div>
    </div>
  );
}

export default ErrorPiecework;
